import ApiService from "../../common/services/ApiService";

const api = new ApiService();

export const sendProfileExportEmail = async (id) => {
  try {
    const response = await api.post(`/api/v1/profiles/${id}/export_summary_supervisor`, {});
    return response.json;
  } catch (error) {
    console.error('sendProfileExportEmail error:', error);
    throw error;
  }
};

export const getProfileDomains = async (id) => {
  try {
    const domains = await api.query(`/api/v1/profiles/${id}/domains`);
    return domains.data;
  } catch (error) {
    console.error('getProfileDomains error:', error);
  }
};

export const getMostRecentProfileForUser = async (userId, namedFilter) => {
  try {
    const profiles = await api.query(`/api/v1/profiles?named_filter=${namedFilter}&q[user_id_eq]=${userId}&q[s]=created_at+desc&per_page=1`);
    return profiles.data;
  } catch (error) {
    console.error('getMostRecentProfileForUser error:', error);
  }
};

export const getProfiles = async (namedFilter) => {
  try {
    const profiles = await api.query(`/api/v1/profiles?named_filter=${namedFilter}&per_page=25&q[s]=educator_completed_at+asc`);
    return profiles.data;
  } catch (error) {
    console.error('getProfiles error:', error);
  }
};

export const getProfilesForSupervisor = async (namedFilter, supervisorId, sortOrder) => {
  try {
    const profiles = await api.query(`/api/v1/profiles?named_filter=${namedFilter}&q[user_supervisor_id_or_user_supervisor_2_id_eq]=${supervisorId}&per_page=100&q[s]=${encodeURIComponent(sortOrder)}`);
    return profiles.data;
  } catch (error) {
    console.error('getProfilesForSupervisor error:', error);
  }
};

export const getProfile = async (profileId) => {
  try {
    const profile = await api.query(`/api/v1/profiles/?q[id_eq]=${profileId}`);
    return profile.data[0];
  } catch (error) {
    console.error('getProfile error:', error);
  }
};
